import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { FEATURE_FLAGS } from "../../constants/FeatureFlags.ts";
import RouterConstants from "../../constants/RouterConstants";
import { useLdFeatureFlag } from "../../hooks/useLdFeatureFlag.ts";
import TabsLayout, { ITabLayout } from "../../layout/TabsLayout/TabsLayout";
import styles from "./ImageEditing.module.scss";

const ImageEditing = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageEditing" });
	const isVideoEditingEnabled = useLdFeatureFlag(FEATURE_FLAGS.VIDEO_EDITING_FEATURE);

	const subTabs: ITabLayout[] = [
		{
			name: t("api.objectContentManipulationTab"),
			link: RouterConstants.IMAGE_EDITING.OBJECT_CONTENT_MANIPULATION.path,
		},
		{ name: t("api.styleAtmosphereTab"), link: RouterConstants.IMAGE_EDITING.STYLE_ATMOSPHERE.path },
		{ name: t("api.backgroundCompositionTab"), link: RouterConstants.IMAGE_EDITING.BACKGROUND_COMPOSITION.path },
		{ name: t("api.restorationEnhancementTab"), link: RouterConstants.IMAGE_EDITING.RESTORATION_ENHANCEMENT.path },
	];

	if (isVideoEditingEnabled) {
		subTabs.push({ name: t("api.videoTab"), link: RouterConstants.IMAGE_EDITING.VIDEO.path });
	}
	const header = isVideoEditingEnabled ? t("ImageAndVideoEditingHeader") : t("ImageEditingHeader");

	return (
		<TabsLayout contentClassName={styles.content} title={header} subTabs={subTabs}>
			<Outlet />
		</TabsLayout>
	);
};

export default observer(ImageEditing);
